import { render, staticRenderFns } from "./infoAdmin.vue?vue&type=template&id=37757c29&"
import script from "./infoAdmin.vue?vue&type=script&lang=js&"
export * from "./infoAdmin.vue?vue&type=script&lang=js&"
import style0 from "./infoAdmin.vue?vue&type=style&index=0&id=37757c29&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports